import {AlertController, Loading, LoadingController, ToastController} from 'ionic-angular';
import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {AppSettings} from "./app-settings";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class NotificationService {
  public loading: Loading;

  constructor(public loadingCtrl: LoadingController,
              public translate: TranslateService,
              public httpClient: HttpClient,
              public alert: AlertController,
              public toast: ToastController) {
  }

  showLoading(content: string, spinner: string, i18n: boolean, next_action: any = () => {
  }) {
    if (i18n) {
      this.translate.get(content).subscribe((res: string) => {
        this.loading = this.loadingCtrl.create({
          spinner: spinner,
          content: res,
          duration: 38200
        });
        this.loading.present().then(next_action);
      });
    } else {
      this.loading = this.loadingCtrl.create({
        spinner: spinner,
        content: content
      });
      this.loading.present().then(next_action);
    }
  }

  hideLoading(next_action: any = () => {
  }) {
    this.loading.dismiss().then(() => {
      next_action();
    }, () => {
      next_action();
    });
  }

  showAlert(title: string, subtitle: string, button_text: string, i18n: boolean) {
    if (i18n) {
      this.translate.get(title).subscribe((res_title: string) => {
        this.translate.get(subtitle).subscribe((res_subtitle: string) => {
          this.translate.get(button_text).subscribe((res_button_text: string) => {
            let alert = this.alert.create({
              title: res_title,
              subTitle: res_subtitle,
              buttons: [res_button_text]
            });
            alert.present().then();
          });
        });
      });
    } else {
      let alert = this.alert.create({
        title: title,
        subTitle: subtitle,
        buttons: [button_text]
      });
      alert.present().then();
    }
  }

  showConfirm(title: string, message: string, button_text: string, button_cancel_text: string, i18n: boolean, next_action: any) {
    if (i18n) {
      this.translate.get(title).subscribe((res_title: string) => {
        this.translate.get(message).subscribe((res_message: string) => {
          this.translate.get(button_text).subscribe((res_button_text: string) => {
            this.translate.get(button_cancel_text).subscribe((res_button_cancel_text: string) => {
              let alert = this.alert.create({
                title: res_title,
                subTitle: res_message,
                buttons: [{
                  text: res_button_cancel_text,
                  role: 'cancel',
                  handler: () => {
                  }
                }, {
                  text: res_button_text,
                  handler: next_action
                }]
              });
              alert.present().then();
            });
          });
        });
      });
    } else {
      let alert = this.alert.create({
        title: title,
        subTitle: message,
        buttons: [{
          text: button_cancel_text,
          role: 'cancel',
          handler: () => {
          }
        }, {
          text: button_text,
          handler: next_action
        }]
      });
      alert.present().then();
    }
  }

  showToast(message: string, i18n: boolean) {
    if (i18n) {
      this.translate.get(message).subscribe((res: string) => {
        let toastItem = AppSettings.TOAST;
        toastItem["message"] = res;
        let toast = this.toast.create(toastItem);
        toast.present();
      });
    } else {
      let toastItem = AppSettings.TOAST;
      toastItem["message"] = message;
      let toast = this.toast.create(toastItem);
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/notification-service.ts